import { Component, OnInit } from '@angular/core';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-photo-gallery',
  templateUrl: './photo-gallery.component.html',
  styleUrls: ['./photo-gallery.component.css']
})
export class PhotoGalleryComponent implements OnInit {
  objArr:any = [];
  deletingIndex: number | null = null;
  baseUrl = environment.imgUrl;

  constructor(private authService: AuthservicesService) {

  }
  ngOnInit() {
    this.getPhotoGallery()
  }

  renderImage(image:any) {
    if (image !== undefined || image !== null) {
      const [baseUrl, imgUrl] = image.split('uploads');
      return `${this.baseUrl}uploads${imgUrl}`
    } else {
      return 'assets/images/church.jpeg'
    }
    // let image = this.authService.spilturl(e)
    // return image;
  }

  getPhotoGallery() {
    this.authService.getGalleryImages().subscribe((res: any) => {
      this.objArr = res.data.images
      console.log(res, 'data')
    },
      error => {
        console.log(error)
      })
  }


  deleteImages(i){
    if(this.objArr.length == 0 || !this.objArr[i]) return

    const deletedImage = this.objArr[i]
    this.deletingIndex = i
    this.authService.deleteGalleryImage({ imagePath: deletedImage }).subscribe((res: any) => {
        console.log(res)
        this.objArr.splice(i,1)
        this.deletingIndex = null
        this.authService.successMessage('Image has been deleted.','success')

      },
        error => {
          this.deletingIndex = null
          console.log(error)
        }
      )

  }



}
